import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Mail, Phone, MapPin } from "lucide-react";
export default function GetInTouchWithAranGroup() {
  return <section className="py-16 px-6 lg:px-8 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto text-center animate-fade-in-up">
          <h2 className="text-4xl font-bold text-foreground mb-6">
            Get in Touch with Aran Group
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed mb-8">
            Have questions about our consulting services or need guidance on your next project? 
            We're here to help you navigate from concept to completion. Reach out to our team at 
            Aran Group, and let's discuss how we can support your business goals with our expertise 
            in product strategy, operational efficiency, and technical solutions.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Link to="/ContactPage">
              <Button size="lg" className="btn-primary">
                <Mail className="size-5" />
                Contact Us
              </Button>
            </Link>
            <Button variant="outline" size="lg">
              <Phone className="size-5" />
              (305) 342-5287
            </Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
            <div className="card p-6 text-center" data-index="0">
              <Mail className="size-8 text-primary mx-auto mb-3" />
              <h3 className="font-semibold text-foreground mb-2">Email</h3>
              <p className="text-sm text-muted-foreground">
                alvaro@arangroup.net
              </p>
            </div>

            <div className="card p-6 text-center" data-index="1">
              <Phone className="size-8 text-primary mx-auto mb-3" />
              <h3 className="font-semibold text-foreground mb-2">Phone</h3>
              <p className="text-sm text-muted-foreground">
                (305) 342-5287
              </p>
            </div>

            <div className="card p-6 text-center" data-index="2">
              <MapPin className="size-8 text-primary mx-auto mb-3" />
              <h3 className="font-semibold text-foreground mb-2">Location</h3>
              <p className="text-sm text-muted-foreground">16660 Sw 85th Lane<div>Miami, FL 33193</div></p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}